import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ReportBuilderService } from '../../../report-builder.service';
import { CsvExportUtils } from '../../../../../shared/utils/csv-export-utils';
import { MomentDateUtils } from '../../../../../shared/utils/moment-date-utils';
import { DateRangeType } from '../../../../../shared/domain/date-range-type.enum';
import { DateRangeHolder } from '../../../../../shared/domain/date-range-holder.model';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SummedMasterReport } from '../../../../shared/domain/report/summed-master-report.model';


@Component({
  selector: 'cm-report-presets-video-unit',
  templateUrl: './report-presets-video-units.component.html',
  styleUrls: ['./report-presets-video-units.component.scss']
})
export class ReportPresetsVideoUnitsComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  MomentDateUtils = MomentDateUtils;

  dataSource = new MatTableDataSource<SummedMasterReport>();
  loading = false;

  columns = ['publisherName', 'bridgeAdUnitName', 'salesRepresentative', 'accountManagerEmail', 'impressions', 'adRequests', 'revenue', 'netRevenue'];
  days: string[] = [];

  filter = {
    name: '',
    publisherId: '',
    salesRepresentativeEmail: '',
    accountManagerEmail: '',
    dateFrom: MomentDateUtils.nDaysFromToday(-9),
    dateTo: MomentDateUtils.nDaysFromToday(-2),
  };
  nameCtrl = new FormControl();

  dateSelector = {
    dateFrom: this.MomentDateUtils.getDatesFromRange(DateRangeType.LAST_30_DAYS).dateFrom,
    dateTo: MomentDateUtils.yesterday(),
    maxDate: MomentDateUtils.yesterday(),
    allowedDateRangeTypes: [
      DateRangeType.YESTERDAY,
      DateRangeType.THIS_WEEK,
      DateRangeType.LAST_7_DAYS,
      DateRangeType.LAST_MONTH,
      DateRangeType.LAST_30_DAYS
    ],
    onDateRangeChanged: (event: DateRangeHolder) => {
      this.dateSelector.dateFrom = event.dateFrom;
      this.dateSelector.dateTo = event.dateTo;
      this.filter.dateFrom = event.dateFrom;
      this.filter.dateTo = event.dateTo;
      this.refreshData();
    }
  };

  constructor(private service: ReportBuilderService, private router: Router, private location: Location, private route: ActivatedRoute, private matDialog: MatDialog) {
    this.route
      .queryParams
      .subscribe(params => {
        Object.assign(this.filter, params);
        this.filter.dateFrom = params['dateFrom'] || this.filter.dateFrom;
        this.filter.dateTo = params['dateTo'] || this.filter.dateTo;
        this.filter.publisherId = params['publisherId'] || this.filter.publisherId;
        this.dateSelector.dateFrom = this.filter.dateFrom;
        this.dateSelector.dateTo = this.filter.dateTo;
      });
  }

  ngOnInit(): void {
    this.refreshData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    const customFilterFn = (data: SummedMasterReport, filter: string) => {
      const nameFilterOk = !this.filter.name || (
        data.publisherName.toLowerCase().includes(this.filter.name.toLowerCase())
        || (data.salesRepresentativeEmail && data.salesRepresentativeEmail.toLowerCase().includes(this.filter.name.toLowerCase()))
      );
      return nameFilterOk;
    };
    this.dataSource.filterPredicate = customFilterFn;

    this.nameCtrl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(next => {
        this.filter.name = next;
        this.filterData();
      });
  }

  filterData() {
    this.dataSource.filter = <string>(this.filter ? this.filter : '');
  }

  refreshData() {
    this.loading = true;

    const params = this.filter;
    const urlTree = this.router.createUrlTree([], {
      queryParams: params,
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
    this.location.replaceState(urlTree.toString());

    this.service.videoUnits({
      dateFrom: this.dateSelector.dateFrom,
      dateTo: this.dateSelector.dateTo,
      salesRepresentativeEmail: this.filter.salesRepresentativeEmail,
      accountManagerEmail: this.filter.accountManagerEmail,
      publisherIds: this.filter.publisherId ? [this.filter.publisherId] : null,
    }).subscribe(result => {
      this.loading = false;
      this.dataSource.data = result;
    }, error => {
      this.loading = false;
    });
  }

  exportData() {
    const dataToExport = this.dataSource.data.map(item => {
      const dataObject = {
        'Publisher': item.publisherName,
        'Ad unit': item.bridgeAdUnitName,
        'Sales Representative': item.salesRepresentativeEmail,
        'Account manager': item.accountManagerEmail,
        'Impressions': item.impressions,
        'Ad reqests': item.adRequests,
        'Revenue': item.revenue,
        'Profitability': item.netRevenue,
        'IO CPM': item.ioCpm,
        'Margin': item.margin,
      };
      return dataObject;
    });
    CsvExportUtils.exportCsv(dataToExport, 'Preset report-' + new Date() + '.csv');
  }


}
